<template>
  <div class="container">
    <div class="" style="display: flex;flex-direction: row;align-items: center;margin-bottom: 10px;">
        <i class="el-icon-s-fold" ></i>
        <el-breadcrumb separator="/" >
          <el-breadcrumb-item >内容管理</el-breadcrumb-item>
          <el-breadcrumb-item class="bread" :to="{ path: '/manage/rules/rules-list' }">识别码管理</el-breadcrumb-item>
          <el-breadcrumb-item >新增耗材识别规则</el-breadcrumb-item>
        </el-breadcrumb>
    </div>
    <div class="equip-add">
      <dv-border-box-12 style="padding: 5px 0px;">
        <div style="padding:1px 6px 0px 6px">
          <div class="header-common">
            <div class="header-common-left">
              <div class="title">新增耗材识别规则</div>
            </div>
          </div>
          <el-form
            :model="form"
            label-width="100px"
            class="add-form"
            :rules="rules"
            ref="form">
            <el-form-item label="识别代码" prop="code">
              <el-input id="code" v-model="form.code" placeholder="" >
              </el-input>
            </el-form-item>
            <el-form-item label="产品名称" prop="name" style="margin-top: 36px;" class="error">
              <el-input id="name" v-model="form.name" placeholder="">
              </el-input>
            </el-form-item>
            <el-form-item label="规格型号" prop="model" style="margin-top: 36px;" class="error">
              <el-input id="model" v-model="form.model" placeholder="">
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" class="action-button" @click="submitForm('form')">立即保存</el-button>
              <el-button class="action-button" @click="resetForm('form')">重置</el-button>
            </el-form-item>
          </el-form>
        </div>
      </dv-border-box-12>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        type:'',
        form: {
          code: '',
          model: '',
          name:''
        },
        rules: {
          code: [{ required: true, message: '请填写耗材识别代码', trigger: 'blur' }],
          model: [{ required: true, message: '请填写规格型号', trigger: 'blur' }],
          name: [{ required: true, message: '请填写产品名称', trigger: 'blur' }],
        },
      }
    },
    methods: {
      onSubmit() {
        console.log('submit!');
      },

      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.addOneConsRule()
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },

      addOneConsRule(){
        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/consumable/type/add';
        const data = {
          'code':this.form.code,
          'model':this.form.model,
          'name':this.form.name
        };

        this.$http({
          method:'POST',
          url:url,
          data:data,
          headers:headers
        }).then(res=>{
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){
              this.$message({
                type:'success',
                message:'新增成功'
              })
              this.resetForm('form');
            }else{
              this.$message.error(obj.message);
            }
          }else{
            this.$message.error(res.data.message);
          }

        }).catch(err=>{
          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })
      },

      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
    },
  }
</script>


<style lang="scss" scoped>
  .container {
    height: 100%;
    margin-top: $header-height;

    .bread >>>.el-breadcrumb__inner{
      color: #606266;
      font-weight: 400;
    }

    .header-common{
      width: 100%;
      height: 45px;
      border-radius: 12px 12px 0 0 ;
      background: linear-gradient(-90deg, #001940, #1564BE);
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;

      .header-common-left{
        font-size: 20px;
        font-weight: bold;
        color: #FEFEFE;
        margin-left: 21px;
        .title{
          font-size: 20px;
          font-weight: bold;
          color: #FEFEFE;
        }
      }
    }

    .equip-add{
      width: 100%;
      float: left;

      .add-form{
        padding: 25px 5px;

          .distinguish{
            display: flex;
            flex-direction: row;
          }

          .action-button{
            width: 120px;
            height: 40px;
            background: #FAFAFA;
            border: 1px solid rgba(0,144,255,0.84);
            border-radius: 20px;
            background-color: #20478D;
            font-size: 14px;
            font-weight: 400;
            color: #00DEFF;
          }

          .error{
          }
      }
    }


  }

</style>



// WEBPACK FOOTER //
// src/view/manage/rules/rules-add-cons.vue